export default __webpack_public_path__ + "static/media/familyandfriendsinvestors.0eb607cb.pdf";